import React, { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";
import { SignIn } from "../pages/common/SignIn";
import { ConfigEditContract } from "../pages/web/ConfigEditContract";
import { ConfigEditSite } from "../pages/web/ConfigEditSite";
import { UploadFiles } from "../pages/web/UploadFiles";
import { Simulation } from "../pages/web/Simulation";
import { ModifySimulation } from "../pages/web/ModifiySimulation";
import { DashboardGeneral } from "../pages/web/DashboardGeneral";
import { Audit } from "../pages/web/Audit";
import { Execute } from "../pages/web/Execute";
import { Site } from "../pages/common/Site";
import { Home } from "../pages/common/Home";
import { Review } from "../pages/web/Review";
import { Forecast } from "../pages/web/Forecast";

const ProtectedRoute = ({ element: Component }) => {
	const { authenticated, authLoading } = useContext(GlobalContext);
	const location = useLocation();
	if (authLoading) return null; // o un loader
	return authenticated ? Component : <Navigate to="/signin" replace state={{ from: location }} />;
};
const DashboardGuard = ({ children }) => {
	const { authenticated, isGranted } = useContext(GlobalContext);
	const can = authenticated && isGranted("Dashboard", "Ver el módulo de dashboard");
	return can ? children : <Navigate to="/signin" />;
};
const WebPaths = () => {
	const { authenticated, viewPermissions, isGranted } = useContext(GlobalContext);

	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const redirectTo = params.get("redirect") || "/site";
	return (
		<Routes>
			<Route path="/" element={authenticated ? <Navigate to="/site" /> : <Navigate to="/signin" />} />
			<Route
				path="/signin"
				element={authenticated ? <Navigate to={redirectTo} replace /> : <SignIn />}
			/>
			<Route path="/site" element={<ProtectedRoute element={<Site />} />} />
			<Route path="/home" element={<ProtectedRoute element={<Home />} />} />
			{/* Config routes */}
			<Route
				path="/config/configedit"
				element={
					authenticated &&
					viewPermissions.config &&
					isGranted("Configuración", "Editar Contrato", "Editar contrato") ? (
						<ConfigEditContract />
					) : (
						<Navigate to="/signin" />
					)
				}
			/>
			<Route
				path="/config/configeditsite"
				element={
					authenticated &&
					viewPermissions.config &&
					isGranted("Configuración", "Editar Site", "Actualizó configuración del Site") ? (
						<ConfigEditSite />
					) : (
						<Navigate to="/signin" />
					)
				}
			/>
			{/* Feature routes */}
			<Route
				path="/upload"
				element={authenticated && viewPermissions.upload ? <UploadFiles /> : <Navigate to="/signin" />}
			/>
			<Route
				path="/simulation"
				element={
					authenticated && viewPermissions.simulation ? <Simulation /> : <Navigate to="/signin" />
				}
			/>
			<Route
				path="/simulation/modifysimulation"
				element={
					authenticated &&
					viewPermissions.simulation &&
					isGranted("Simulación", "Crear formulario de simulación (simulación desde 0)") ? (
						<ModifySimulation />
					) : (
						<Navigate to="/signin" />
					)
				}
			/>
			<Route
				path="/dashboard"
				element={
					<DashboardGuard>
						<DashboardGeneral />
					</DashboardGuard>
				}
			/>

			<Route
				path="/audit"
				element={authenticated && viewPermissions.audit ? <Audit /> : <Navigate to="/signin" />}
			/>
			<Route
				path="/execute"
				element={authenticated && viewPermissions.execute ? <Execute /> : <Navigate to="/signin" />}
			/>

			<Route
				path="/review"
				element={authenticated && viewPermissions.review ? <Review /> : <Navigate to="/signin" />}
			/>

			<Route
				path="/forecast"
				element={authenticated && viewPermissions.execute ? <Forecast /> : <Navigate to="/signin" />}
			/>

			{/* 404 route */}
			<Route path="*" element={<Navigate to="/" replace />} />

			{/* <Route path="/Execute" element={<Execute />} />

				<Route path="/Audit" element={<Audit />} />
		

				<Route path="/Upload" element={<UploadFiles />} /> */}

			{/* <Route path="/charts/:initialDataId" element={<ChartsPage />} /> */}

			{/* <Route path="*" element={<>404 page not found</>} /> */}
			{/* <Route path="/Config" element={<Config />} /> */}
		</Routes>
	);
};

// const MobilePaths = () => {
// 	const { authenticated, viewPermissions, isGranted } = useContext(GlobalContext);

// 	return (
// 		<Routes>
// 			{/* Default route */}
// 			<Route path="/" element={authenticated ? <Navigate to="/site" /> : <Navigate to="/signin" />} />
// 			{/* Auth route */}
// 			<Route path="/signin" element={authenticated ? <Navigate to="/site" /> : <SignIn />} />

// 			{/* Protected routes */}
// 			<Route path="/site" element={authenticated ? <Site /> : <Navigate to="/signin" />} />
// 			<Route path="/home" element={authenticated ? <Home /> : <Navigate to="/signin" />} />

// 			{/* Config routes */}
// 			<Route
// 				path="/config/configcreate"
// 				element={
// 					authenticated &&
// 					viewPermissions.config &&
// 					isGranted("Configuración", "Crear Contrato", "Ver el módulo de crear contratos") ? (
// 						<ConfigCreate />
// 					) : (
// 						<Navigate to="/signin" />
// 					)
// 				}
// 			/>
// 			<Route
// 				path="/config/configedit"
// 				element={
// 					authenticated &&
// 					viewPermissions.config &&
// 					isGranted("Configuración", "Editar Contrato", "Editar contrato") ? (
// 						<ConfigEditContract />
// 					) : (
// 						<Navigate to="/signin" />
// 					)
// 				}
// 			/>
// 			<Route
// 				path="/config/configeditsite"
// 				element={
// 					authenticated &&
// 					viewPermissions.config &&
// 					isGranted("Configuración", "Editar Site", "Actualizó configuración del Site") ? (
// 						<ConfigEditSite />
// 					) : (
// 						<Navigate to="/signin" />
// 					)
// 				}
// 			/>
// 			{/* Feature routes */}
// 			<Route
// 				path="/upload"
// 				element={authenticated && viewPermissions.upload ? <UploadFiles /> : <Navigate to="/signin" />}
// 			/>
// 			<Route
// 				path="/simulation"
// 				element={
// 					authenticated && viewPermissions.simulation ? <Simulation /> : <Navigate to="/signin" />
// 				}
// 			/>
// 			<Route
// 				path="/simulation/modifysimulation"
// 				element={
// 					authenticated &&
// 					viewPermissions.simulation &&
// 					isGranted("Simulación", "Crear formulario de simulación (simulación desde 0)") ? (
// 						<ModifySimulation />
// 					) : (
// 						<Navigate to="/signin" />
// 					)
// 				}
// 			/>
// 			<Route
// 				path="/dashboard"
// 				element={
// 					authenticated && viewPermissions.dashboard ? <DashboardGeneral /> : <Navigate to="/signin" />
// 				}
// 			/>
// 			<Route
// 				path="/audit"
// 				element={authenticated && viewPermissions.audit ? <Audit /> : <Navigate to="/signin" />}
// 			/>
// 			<Route
// 				path="/execute"
// 				element={authenticated && viewPermissions.execute ? <Execute /> : <Navigate to="/signin" />}
// 			/>
// 			<Route
// 				path="/review"
// 				element={authenticated && viewPermissions.simulation ? <Review /> : <Navigate to="/signin" />}
// 			/>

// 			{/* 404 route */}
// 			<Route path="*" element={<Navigate to="/" replace />} />

// 			{/* <Route path="/Execute" element={<Execute />} />

// 				<Route path="/Audit" element={<Audit />} />

// 				<Route path="/Upload" element={<UploadFiles />} /> */}

// 			{/* <Route path="/charts/:initialDataId" element={<ChartsPage />} /> */}

// 			{/* <Route path="*" element={<>404 page not found</>} /> */}
// 			{/* <Route path="/Config" element={<Config />} /> */}
// 		</Routes>
// 	);
// };

export { WebPaths };
